/**
 * Expense Resource
 */
import Resource from "./Resource";

/**
 * MessageBox Resource.
 */
class MessageBox extends Resource
{
    constructor() {
        super('inbox.messagebox', ['inbox']);
    }
}

const MessageBoxResource = new MessageBox()

/**
 * MessageBox Schema.
 */
const MessageBoxSchema = function(defaults = {}) {
    let schema = {
        name: ''
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
}

/**
 * Conversation Resource.
 */
class Conversation extends Resource
{
    constructor() {
        super('inbox.conversation', ['inbox', 'conversations']);
    }

    start(message, params = {}, data = {}) {
        return this._doPost(['start'], { message, ...data }, params)
    }

    log(contact, subject, content, message_box_id, params = {}) {
        return this._doPost(['log'], { contact, subject, content, message_box_id}, params)
    }

    reply(conversation_id, medium, content, params = {}, data = {}) {
        return this._doPost([conversation_id, 'reply'], { message: { content, medium }, ...data }, params)
    }

    assignUser(conversation_id, user_id) {
        return this._doPut([conversation_id, 'assign'], { user_id })
    }

    unassignUser(conversation_id, user_id) {
        return this._doPut([conversation_id, 'unassign'], { user_id })
    }

    unassignAll(conversation_id) {
        return this._doPut([conversation_id, 'unassign'], { all: true })
    }

    status(conversation_id, status) {
        return this._doPut([conversation_id, 'status'], { status })
    }

    transfer(conversation_id, message_box_id) {
        return this._doPut([conversation_id, 'transfer'], { message_box_id })
    }

    options(params) {
        return this._doGet(['options'], params);
    }
}

let ConversationResource = new Conversation()

const MessageTypes = {
    TYPE_EMAIL: 'email',
    TYPE_TEXT: 'text',
}

const MessageTypeList = [{
    label: 'Email',
    value: MessageTypes.TYPE_EMAIL
},{
    label: 'Text',
    value: MessageTypes.TYPE_TEXT
}]

const ConversationStatuses = {
    STATUS_WAITING: 'waiting',
    STATUS_FOLLOW_UP: 'follow-up',
    STATUS_CLOSED: 'closed',
    STATUS_BIN: 'bin',
    STATUS_JUNK: 'junk'
}

const MessageBodyPartTypes = {
    TYPE_PLAIN: 'plain',
    TYPE_HTML: 'html',
    TYPE_JSON: 'json',
    TYPE_MIME: 'mime',
}

const ConversationStatusList = [
    {
        value: ConversationStatuses.STATUS_WAITING,
        label: 'Waiting'
    },{
        value: ConversationStatuses.STATUS_FOLLOW_UP,
        label: 'Follow Up'
    },{
        value: ConversationStatuses.STATUS_CLOSED,
        label: 'Closed'
    },{
        value: ConversationStatuses.STATUS_BIN,
        label: 'Bin'
    },{
        value: ConversationStatuses.STATUS_JUNK,
        label: 'Junk'
    },
]

export {
    MessageBoxResource, MessageBoxSchema, ConversationResource, MessageTypes, MessageTypeList,
    ConversationStatuses, ConversationStatusList, MessageBodyPartTypes
}